{
  "name": "vinfo",
  "version": "1.3.23-SNAPSHOT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-dev": "ng serve --configuration=dev",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@acpgruppe/essp-ui": "19.1.9",
    "@angular/animations": "19.2.20",
    "@angular/common": "19.2.20",
    "@angular/compiler": "19.2.20",
    "@angular/core": "19.2.20",
    "@angular/elements": "19.2.20",
    "@angular/forms": "19.2.20",
    "@angular/localize": "19.2.20",
    "@angular/platform-browser": "19.2.20",
    "@angular/platform-browser-dynamic": "19.2.20",
    "@angular/router": "19.2.20",
    "@auth0/angular-jwt": "^5.0.2",
    "@popperjs/core": "^2.11.6",
    "@ungap/custom-elements": "^1.1.1",
    "@webcomponents/custom-elements": "^1.4.3",
    "angular-animations": "^0.11.0",
    "angular-oauth2-oidc": "^19.0.0",
    "bootstrap": "^5.2.3",
    "bootstrap-icons": "^1.9.1",
    "chart.js": "^4.5.1",
    "chartjs-adapter-date-fns": "^3.0.0",
    "core-js": "^3.18.3",
    "date-fns": "^4.1.0",
    "document-register-element": "^1.7.2",
    "docx": "^9.5.0",
    "file-saver": "^2.0.5",
    "html-minifier": "^4.0.0",
    "jodit": "^4.0.1",
    "mkdirp": "^1.0.4",
    "ngx-toastr": "^18.0.0",
    "primeicons": "^6.0.1",
    "primeng": "^19.1.4",
    "quill": "^1.3.7",
    "rxjs": "^7.8.0",
    "tslib": "^2.4.0",
    "uuid": "^9.0.0",
    "xlsx": "^0.18.5",
    "xmldom": "^0.6.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.20",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "19.2.20",
    "@angular/compiler-cli": "19.2.20",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "5.59.2",
    "@typescript-eslint/parser": "5.59.2",
    "@webcomponents/webcomponentsjs": "^2.5.0",
    "autoprefixer": "^10.4.27",
    "eslint": "^8.39.0",
    "eslint-plugin-css": "^0.12.0",
    "jasmine-core": "~4.5.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "postcss": "^8.5.8",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "typescript": "~5.5.4",
    "web-components-loader": "^0.1.2"
  }
}
